"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectionIndicatorStyles = void 0;
const styles_1 = require("@mui/material/styles");
const useSelectionIndicatorStyles = ({ elevated, disabled, isExpanded }) => {
    const theme = (0, styles_1.useTheme)();
    const wrapper = {
        transition: 'all 0.1s ease-in-out',
        width: isExpanded ? '92px' : '28px',
        height: '28px',
        overflow: 'hidden',
        borderRadius: '4px',
        boxShadow: elevated ? '0px 2px 8px rgba(0, 0, 0, 0.15)' : 'none',
        '&:hover': {
            boxShadow: elevated ? '0px 4px 12px rgba(0, 0, 0, 0.2)' : 'none',
        },
        'html[dir="rtl"] &': {
            transition: 'all 0.1s ease-in-out',
        },
    };
    const container = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '4px',
        border: `1px solid ${disabled ? theme.palette.action.disabledBackground : 'rgba(0, 0, 0, 0.12)'}`,
    };
    const button = {
        width: '28px',
        height: '28px',
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    };
    const icon = {
        fontSize: 21,
        color: disabled ? theme.palette.action.disabled : theme.palette.common.black,
    };
    const value = {
        flex: 1,
        textAlign: 'center',
        fontSize: '14px',
        lineHeight: '28px',
        color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    };
    return { wrapper, container, button, icon, value };
};
exports.useSelectionIndicatorStyles = useSelectionIndicatorStyles;
